import React from 'react';

import { IconProps } from './types';

const Icon = ({ src, alt, size = 10, style }: IconProps) => (
  <img
    src={src}
    alt={alt}
    style={{
      width: size,
      height: size,
      ...style,
    }}
  />
);

export default Icon;
